import './PageTitleBlock.css';

export default function PageTitleBlock({
  before = null,
  eyebrow = '',
  title,
  description = '',
  className = '',
}) {
  const classes = [
    'vnext-page-title-block',
    before ? 'has-prelude' : '',
    eyebrow ? 'has-eyebrow' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {before}
      {eyebrow && <p className="vnext-page-title-eyebrow">{eyebrow}</p>}
      <h1>{title}</h1>
      {description && <p className="vnext-page-title-description">{description}</p>}
    </div>
  );
}
